import {useMutation} from '@tanstack/react-query';

import {useClient} from 'context/auth-context';
import {
    IConnectInviteBusinessPartner,
    IConnectInviteBusinessPartnerCreate,
} from 'types/api';
import {PATCH_HEADERS} from './constants';

const useConnectInvitedBpRequest = () => {
    const client = useClient();

    return useMutation<
        IConnectInviteBusinessPartner,
        unknown,
        IConnectInviteBusinessPartnerCreate
    >({
        mutationFn: request => {
            const {id, data} = request;

            return client(
                `/web_api/contact_invites/${id}/connect_invited_business_partner`,
                {
                    data,
                    method: 'PATCH',
                    ...PATCH_HEADERS,
                },
            );
        },
    });
};

export {useConnectInvitedBpRequest};
